
<div class="footer-container center">
    <p class="footer-text">
        Contact Us: <img src="assets/email.png" class="haggard-img"/>
    </p>
    <div>
        <a routerLink="/login">Login</a>
    </div>
</div>